import {mapGetters} from 'vuex';
import {roles} from '@/constants/roles-constants';

export const rolesMixin = {
    methods: {
        ...mapGetters([
            'authUser',
        ]),
        $_rolesMixin_checkRoles(rolesToCheck) {

            if (this.authUser() && Array.isArray(rolesToCheck)) {

                return this.authUser().roles.some(role => {
                    const hasSuperAdminRole = role.name === roles.superAdmin;
                    const hasRole = rolesToCheck.some(roleToCheck => role.name.includes(roleToCheck));
                    return hasSuperAdminRole || hasRole;
                });

            } else {
                return true;
            }
        },
        $_rolesMixin_checkRole(roleToCheck) {
            return this.$_rolesMixin_checkRoles([roleToCheck]);
        }
    }
};